import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=53d3f211&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=53d3f211&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3f211",
  null
  
)

export default component.exports